import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FlexLayoutModule } from "@angular/flex-layout";

import { MaterialAppModule } from "../../../ngmaterial.module";
import { PolicyResourceSelectComponent, PolicyGroupSelectComponent, SamlAliasCreateComponent, PolicyWizardService } from "../policy-wizard";
import { CommonModule } from "../../../common/common.module";

@NgModule({
	imports: [
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		FlexLayoutModule,
		BrowserModule,
		CommonModule,
		MaterialAppModule
	],
	declarations: [
		PolicyResourceSelectComponent,
		PolicyGroupSelectComponent,
		SamlAliasCreateComponent
	],
	entryComponents: [
		PolicyResourceSelectComponent,
		PolicyGroupSelectComponent,
		SamlAliasCreateComponent
	],
	providers: [
		PolicyWizardService
	]
})
export class PolicyWizardModule { }
